// NOTE: BEFORE EDIT THIS FILE, PLEASE READ THE NOTES IN shared/core/providers/ThemeProvider.tsx

import {
  // FontResolver,
  createComponents,
  createConfig
} from "@gluestack-style/react";

import { AnimationResolver } from "@gluestack-style/animation-resolver";
import { MotionAnimationDriver } from "@gluestack-style/legend-motion-animation-driver";

import { aliases } from "./aliases";
import * as componentsTheme from "./components";
import { globalStyle } from "./globalStyles";
import { tokens } from "./tokens";

export const gluestackUIConfig = createConfig({
  aliases,
  tokens,
  globalStyle,
  plugins: [
    new AnimationResolver(MotionAnimationDriver) /*, new FontResolver()*/
  ]
});

type Config = typeof gluestackUIConfig;

type Components = typeof componentsConfig;

export const componentsConfig = createComponents(componentsTheme);

export type { UIComponents, UIConfig } from "@gluestack-ui/themed";

export interface IConfig {}
export interface IComponents {}

declare module "@gluestack-ui/themed" {
  interface UIConfig extends Omit<Config, keyof IConfig>, IConfig {}
  interface UIComponents
    extends Omit<Components, keyof IComponents>,
      IComponents {}
}

export const config = {
  ...gluestackUIConfig,
  components: componentsConfig
};
